const axios = require('axios');
require('tempusdominus-bootstrap-4');
// const frmFilters = new Vue({
//     el: '#frmFilters',
//     delimiters: ['${', '}'],
//     data: {
//         output: ''
//     },
//     mounted() {
//         console.log('Component mounted. asasd');
//         var myForm = document.getElementById('myForm');
//         formData = new FormData(myForm);
//         console.log('form', formData);
//     },
//     methods: {
//         getFormValues (){
//             this.output = this.$refs
//         }
//     }
// });

function showLoading() {
    // $('.loading-spinner').show();
    $('.loading-modal').modal('show');
    // $('.loading-modal').on('shown.bs.modal', function(){

    //     setTimeout(() => {
    //         $('.loading-modal').modal('hide');
    //     }, 5000);

    // });
}

function hideLoading() {

    // $('.loading-modal').modal('hide');
    // $('.loading-spinner').hide();
    // console.log('hidee', $('.loading-modal'));
    // $('.loading-modal').removeClass('show');
    // $('.loading-modal').removeClass('show');
    // $('.modal-backdrop').removeClass('show');
    $('.loading-modal').ready(function(){
        setTimeout(function(){
            $('.loading-modal').modal('hide');
        }, 500);
    });
    // console.log('on hide inside showloading');
    // });
}

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
$(document).ready(function(){

    // form inputs
    var form = $('#frmFilters');
    var url = form.attr('action');

    var resultsContainer = form.find('#filtered-area');
    console.log('res', resultsContainer);
    // console.log('url', url);

    $('body').on('change',"#frmFilters select", function(e){
        goSearch(e);
    })

    // $(window).load(function(){
    //     console.log('loadddd');
    // })
    window.onload = function(){
        console.log("LOADED");
        // goSearch(null);
    }

    var previousDate = '';
    function goSearch() {
        const locationURL = new URL(window.location);

        showLoading();

        console.log('is equal', previousDate == $(form[0]).serialize());
        if(previousDate == $(form[0]).serialize()){
            return false;
        }
        previousDate = $(form[0]).serialize();
        var formData = new FormData(form[0]);
        for (let [key, value] of formData) {
            locationURL.searchParams.set(key, value);
        }

        window.history.pushState({}, '', locationURL);

        resultsContainer.html('<p>Carregando...</p>');
        // console.log('resultsContainer', resultsContainer);
        axios.post(locationURL.toString(), formData,).then((response) => {

            // console.log('response', response.data);
            // console.log('this.', this);
            // this.values = response.data;
            // //não encontrou nada
            // if(typeof response.data.data == 'undefined'){
            //     return false;
            // }

            var results = response.data;
            resultsContainer.html(results);

            // console.log('results cont', resultsContainer);
            // console.log('data', results);

            // for(var i = 0; i < results.length; i++){
            //     resultsContainer.append()
            // }
            hideLoading();
            //aplicar o estilo do custom select
            $('.my-custom-select').selectpicker();

        }).catch((error) => {
            hideLoading();
            console.log('houve um erro ao processar o request', error);
        }).then(() => {
            hideLoading();
            // console.log('fim do request');
        });

    }
});